export enum NavigationDepth {
  primary,
  secondary,
  tertiary,
}

export interface HeaderButton {
  queryParams?: { [k: string]: any };
  title: string;
  cssClasses?: string;
  url?: string;
  callback?: () => void;
  navigationDepth?: NavigationDepth;
  warn?: boolean;
  buttonId?: string;
  icon?: string;
  openNewTab?: boolean;
  tooltip?: string;
  disabled?: boolean;
  disabledTooltip?: string;
}
